export class User {
  constructor(public passcode: string) { }
}
